<style lang="less">
    .colorSet {
        height: auto;
        width: 100%;
        position: relative;
        .rPanel-item {
            margin-bottom: 12px;
        }
        .colorSet-item {
            margin-bottom: 12px;
            &.disabled {
                .item-dropbox {
                    background-color: transparent !important;
                    .item-preview {
                        background-color: var(--bg-color-ivu-input-number-input-disabled) !important;
                    }
                }
            }
        }
        .item-preview {
            background-clip: border-box !important;
            height: 18px !important;
            margin: 2px;
            border: 1px solid var(--color-black-8) !important;
            border-radius: 2px;
        }
    }
    .colorSet-slider-box {
        display: flex;
        align-items: center;
        .ivu-slider {
            flex: 1;
            height: 24px;
            margin-right: 32px;
            .ivu-slider-wrap {
                margin: 10px 0;
            }
        }
    }
    .colorSet-item {
        margin-bottom: 12px;
        .colorSet-item-title {
            height: 22px;
            line-height: 22px;
        }
        .ivu-input-number {
            border-radius: 4px;
        }
    }
</style>

<template>
    <div class="colorSet">
        <div class="rPanel-item colorSet-item" :class="{ disabled: isDisabled }" v-if="!(fromPaintType && fromPaintType === 4)">
            <span class="left">{{ $t(type) }}</span>
            <div class="item-dropbox" @click="showPalette">
                <div class="item-preview" :style="{ backgroundColor: color }"></div>
            </div>
        </div>
        <div
            class="colorSet-item"
            :class="{ disabled: isDisabled }"
            v-if="(from === fmtType.fill && fromPaintType && fromPaintType !== 4) || from === fmtType.line"
        >
            <div class="colorSet-item-title">{{ $t("ColorSet.shade") }}</div>
            <div class="colorSet-slider-box">
                <Slider
                    :max="100"
                    :min="-100"
                    v-model="shadeVal"
                    @on-input="modifyTint()"
                    @mousedown.native="modifyTintPreRedo(0)"
                    @mouseup.native="modifyTintRedo(0)"
                ></Slider>
                <InputNumber
                    class="input-num"
                    :max="100"
                    :min="-100"
                    style="width: 80px"
                    size="small"
                    v-model="shadeVal"
                    :active-change="false"
                    :formatter="(value) => `${value}%`"
                    :parser="(value) => value.replace('%', '')"
                    @on-focus="editLocker('focus', 'inputLocker')"
                    @on-blur="
                        editLocker('blur', 'inputLocker', () => {
                            modifyTint();
                            handleChangeSet();
                        })
                    "
                    @on-change="
                        editLocker('edit', 'inputLocker', () => {
                            modifyTint();
                            handleChangeSet();
                        })
                    "
                    @keyup.enter.native="iviewInputBlur($event)"
                ></InputNumber>
            </div>
        </div>
        <div class="colorSet-item last-item" :class="{ disabled: isDisabled }">
            <div class="colorSet-item-title">{{ $t("ColorSet.transparency") }}</div>
            <div class="colorSet-slider-box">
                <Slider
                    :max="100"
                    :min="0"
                    v-model="alphaVal"
                    @on-input="changeAlpha()"
                    :disabled="isDisabled"
                    @mousedown.native="modifyTintPreRedo(1)"
                    @mouseup.native="modifyTintRedo(1)"
                ></Slider>
                <InputNumber
                    class="input-num"
                    :max="100"
                    :min="0"
                    style="width: 80px"
                    size="small"
                    v-model="alphaVal"
                    :disabled="isDisabled"
                    :active-change="false"
                    :formatter="(value) => `${value}%`"
                    :parser="(value) => value.replace('%', '')"
                    @on-focus="editLocker('focus', 'inputLocker')"
                    @on-blur="
                        editLocker('blur', 'inputLocker', () => {
                            changeAlpha();
                            handleChangeSet();
                        })
                    "
                    @on-change="
                        editLocker('edit', 'inputLocker', () => {
                            changeAlpha();
                            handleChangeSet();
                        })
                    "
                    @keyup.enter.native="iviewInputBlur($event)"
                ></InputNumber>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    declare var eFmtSetFlag: any;
    import { Component, Prop, Vue, Inject } from "vue-property-decorator";

    @Component({})
    export default class ColorSet extends Vue {
        @Inject()
        ["iviewInputBlur"];

        @Prop({ default: "Color" }) type!: string;
        @Prop({ default: "#ffffff" }) fromColor!: string;
        @Prop({ default: null }) from!: number;
        @Prop({ default: null }) fromPaintType!: number; // 1,solid,2,gradient,3,pattern,4,texture
        @Prop({ default: null }) index!: number;
        @Prop({ default: false }) isDisabled: boolean;
        // tranVal: number = 0;
        inputLocker: boolean = false;

        tempData = null;
        modifyTintPreRedo(type) {
            (!type && (this.tempData = this.shadeVal)) || (this.tempData = this.alphaVal);
            window["_view"].addFormatPreUndoAct(this.from);
        }
        modifyTintRedo(type) {
            let flag = false;
            (!type && (flag = this.tempData != this.shadeVal)) || (flag = this.tempData != this.alphaVal);
            window["_view"].addFormatUndoAct(flag);
            this.tempData = false;
            this.handleChangeSet();
        }

        editLocker(type, lock, fn?) {
            let map = new Map([
                [
                    "focus",
                    () => {
                        this[lock] = true;
                    },
                ],
                [
                    "blur",
                    () => {
                        this[lock] = false;
                        fn();
                    },
                ],
                [
                    "edit",
                    () => {
                        if (!this[lock]) {
                            fn();
                        }
                    },
                ],
            ]);
            map.get(type)();
        }
        modifyTint() {
            this.$nextTick(() => {
                window["_view"]._tool.endEdit();
                // console.warn("moddddding tint!!!!");
                let view = window["_view"];
                view.setFmt(
                    {
                        _paintType: this.fromPaintType,
                        _index: this.index,
                        _tintNum: this.shadeVal,
                    },
                    eFmtSetFlag.ColorModifyTint | this.from,
                    false
                );
            });
        }
        changeAlpha() {
            this.$nextTick(() => {
                // console.log(this.alphaVal);/
                window["_view"]._tool.endEdit();
                let view = window["_view"];
                if (this.fromPaintType === 4) {
                    view.setFmt(
                        {
                            _alpha: Math.round(255 - (this.alphaVal / 100) * 255),
                        },
                        eFmtSetFlag.FillTextureAlp,
                        false
                    );
                } else {
                    view.setFmt(
                        {
                            _paintType: this.fromPaintType,
                            _index: this.index,
                            _alpha: parseFloat((1 - this.alphaVal / 100).toFixed(2)),
                        },
                        eFmtSetFlag.ColorChangeAlpha | this.from,
                        false
                    );
                }
            });
        }
        handleChangeSet() {
            this.$emit("changeSet");
        }
        showPalette(e): void {
            window["_view"]._tool.endEdit();
            let node = e.target;
            let payload = {
                type: this.from,
                index: this.index,
            };
            this.$store.commit("setColor", payload);
            let type = this.from == this.fmtType.fill ? "RightColorFill" : this.from == this.fmtType.line ? "RightColorLine" : "RightColor";
            this.$nextTick(() => {
                this.$store.dispatch("usePalette", { e, type });
            });
        }

        get fmtType() {
            return this.$store.state.ui.fmtType;
        }
        get color() {
            if (this.from === null) {
                return this.fromColor;
            } else if (this.from === this.fmtType.fill) {
                return this.$store.state.shape.fillFmt.colors[this.index];
            } else if (this.from === this.fmtType.line) {
                return this.$store.state.shape.lineFmt.colors[this.index];
            } else if (this.from === this.fmtType.shadow) {
                return this.$store.state.shape.shadowFmt.color;
            }
        }
        get shadeVal() {
            if (this.from === null) {
                return 0;
            } else if (this.from === this.fmtType.fill) {
                return this.$store.state.shape.fillFmt.tints[this.index];
            } else if (this.from === this.fmtType.line) {
                return this.$store.state.shape.lineFmt.tints[this.index];
            } else if (this.from === this.fmtType.shadow) {
                return this.$store.state.shape.shadowFmt.tint;
            }
            return 0;
        }
        set shadeVal(v: any) {
            let payload = {
                type: "tints",
                data: v,
                index: this.index,
            };
            if (this.from === null) {
            } else if (this.from === this.fmtType.fill) {
                this.$store.commit("setFillColorData", payload);
            } else if (this.from === this.fmtType.line) {
                this.$store.commit("setLineColorData", payload);
            } else if (this.from === this.fmtType.shadow) {
            }
        }
        get alphaVal() {
            if (this.from === null) {
                return 0;
            } else if (this.from === this.fmtType.fill) {
                if (this.fromPaintType === 4) {
                    return Math.round(((255 - this.$store.state.shape.fillFmt.textureAlpha) / 255) * 100);
                } else {
                    return Math.round((1 - this.$store.state.shape.fillFmt.alphas[this.index]) * 100);
                }
            } else if (this.from === this.fmtType.line) {
                return Math.round((1 - this.$store.state.shape.lineFmt.alphas[this.index]) * 100);
            } else if (this.from === this.fmtType.shadow) {
                return Math.round((1 - this.$store.state.shape.shadowFmt.alpha) * 100);
            }
            return 0;
        }
        set alphaVal(v: any) {
            let payload =
                this.fromPaintType === 4
                    ? {
                          type: "textureAlpha",
                          data: Math.round(255 - (v / 100) * 255),
                      }
                    : {
                          type: "alphas",
                          data: 1 - v / 100,
                          index: this.index,
                      };
            if (this.from === null) {
            } else if (this.from === this.fmtType.fill) {
                if (this.fromPaintType === 4) {
                    this.$store.commit("setFillFmtData", payload);
                } else {
                    this.$store.commit("setFillColorData", payload);
                }
            } else if (this.from === this.fmtType.line) {
                this.$store.commit("setLineColorData", payload);
            } else if (this.from === this.fmtType.shadow) {
                payload.type = "alpha";
                this.$store.commit("setShadowFmtData", payload);
            }
        }

        mounted() {}

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "Color": "颜色",
    "Foreground": "前景色",
    "Background": "背景色",
    "ColorSet": {
      "shade": "阴影/色调",
      "transparency": "透明度"
    }
  },
  "en": {
    "Color": "Color",
    "Foreground": "Foreground",
    "Background": "Background",
    "ColorSet": {
      "shade": "Shade/Tint",
      "transparency": "Transparency"
    }
  },
  "fr": {
    "Color": "Couleur",
    "Foreground": "Couleur de devant",
    "Background": "Couleur de fond",
    "ColorSet": {
      "shade": "Ombre/Teinte",
      "transparency": "Transparence"
    }
  },
  "de": {
    "Color": "Farbe",
    "Foreground": "Vordergrund",
    "Background": "Hintergrund",
    "ColorSet": {
      "shade": "Schatten/Farbton ",
      "transparency": "Transparent"
    }
  },
  "jp": {
    "ColorSet": {
      "shade": "明るさ",
      "transparency": "透明度"
    },
    "Color": "色",
    "Foreground": "前景色",
    "Background": "背景色"
  },
  "es": {
    "Color": "Color",
    "Foreground": "Primer plano",
    "Background": "Antecedentes",
    "ColorSet": {
      "shade": "Sombra/Tono",
      "transparency": "Transparencia"
    }
  },
  "pt": {
    "Color": "Cor",
    "Foreground": "Primeiro Plano",
    "Background": "Fundo",
    "ColorSet": {
      "shade": "Sombra/Tinta",
      "transparency": "Transparência"
    }
  },
  "it": {
    "Color": "Colore",
    "Foreground": "Primo Piano",
    "Background": "Sfondo",
    "ColorSet": {
      "shade": "Tonalità/Tinta",
      "transparency": "Trasparenza"
    }
  },
  "tw": {
    "Color": "顏色",
    "Foreground": "前景色",
    "Background": "背景色",
    "ColorSet": {
      "shade": "陰影/色調",
      "transparency": "透明度"
    }
  }
}
</i18n>
